import { render, staticRenderFns } from "./ProjectActionApplyOfferRules.vue?vue&type=template&id=6861c7f9&scoped=true"
import script from "./ProjectActionApplyOfferRules.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectActionApplyOfferRules.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectActionApplyOfferRules.vue?vue&type=style&index=0&id=6861c7f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861c7f9",
  null
  
)

export default component.exports